/**
 * Mock Provider Data for Development
 * This provides sample data when the FastAPI backend is not available
 */

import { Provider } from '@/components/provider-directory/ProviderResults';

export const mockProviders: Provider[] = [
  {
    id: '1',
    organization_name: 'Bay Area Community Health Center',
    organization_type: 'FQHC',
    street_address: '123 Main Street',
    city: 'Fremont',
    state: 'CA',
    zip_code: '94539',
    latitude: 37.5485,
    longitude: -121.9886,
    primary_phone: '(510) 555-0100',
    primary_email: 'info@bachc.org',
    website: 'https://example.com',
    distance_miles: 0.5,
    data_quality_score: 95,
    services: ['Primary Care', 'Dental Services', 'Mental Health Services', 'Pharmacy Services'],
    languages_spoken: ['English', 'Spanish', 'Mandarin', 'Vietnamese'],
    accepts_medicaid: true,
    accepts_medicare: true,
    hours_of_operation: {
      monday: '8:00 AM - 5:00 PM',
      tuesday: '8:00 AM - 5:00 PM',
      wednesday: '8:00 AM - 5:00 PM',
      thursday: '8:00 AM - 5:00 PM',
      friday: '8:00 AM - 5:00 PM',
      saturday: '9:00 AM - 1:00 PM',
      sunday: 'Closed'
    },
    wheelchair_accessible: true,
    status: 'active'
  },
  {
    id: '2',
    organization_name: 'East Bay Mental Health Services',
    organization_type: 'Mental Health Center',
    street_address: '456 Oak Avenue',
    city: 'Fremont',
    state: 'CA',
    zip_code: '94538',
    latitude: 37.5437,
    longitude: -122.0054,
    primary_phone: '(510) 555-0200',
    primary_email: 'contact@ebmhs.org',
    website: 'https://example.com',
    distance_miles: 1.2,
    data_quality_score: 88,
    services: ['Mental Health Services', 'Behavioral Health', 'Substance Abuse Treatment', 'Case Management'],
    languages_spoken: ['English', 'Spanish', 'Tagalog'],
    accepts_medicaid: true,
    accepts_medicare: false,
    hours_of_operation: {
      monday: '9:00 AM - 6:00 PM',
      tuesday: '9:00 AM - 6:00 PM',
      wednesday: '9:00 AM - 6:00 PM',
      thursday: '9:00 AM - 6:00 PM',
      friday: '9:00 AM - 6:00 PM',
      saturday: 'Closed',
      sunday: 'Closed'
    },
    wheelchair_accessible: true,
    status: 'active'
  },
  {
    id: '3',
    organization_name: 'Fremont Family Clinic',
    organization_type: 'Free Clinic',
    street_address: '789 Elm Street',
    city: 'Fremont',
    state: 'CA',
    zip_code: '94539',
    latitude: 37.5585,
    longitude: -121.9986,
    primary_phone: '(510) 555-0300',
    website: 'https://example.com',
    distance_miles: 2.1,
    data_quality_score: 75,
    services: ['Primary Care', 'Health Screenings', 'Immunizations'],
    languages_spoken: ['English', 'Spanish', 'Hindi'],
    accepts_medicaid: false,
    accepts_medicare: false,
    wheelchair_accessible: false,
    status: 'active'
  },
  {
    id: '4',
    organization_name: 'South County Food Bank',
    organization_type: 'Food Bank',
    street_address: '321 Pine Road',
    city: 'Fremont',
    state: 'CA',
    zip_code: '94539',
    latitude: 37.5285,
    longitude: -121.9686,
    primary_phone: '(510) 555-0400',
    primary_email: 'help@scfb.org',
    website: 'https://example.com',
    distance_miles: 3.5,
    data_quality_score: 92,
    services: ['Food Assistance', 'Emergency Food', 'Nutrition Education'],
    languages_spoken: ['English', 'Spanish'],
    accepts_medicaid: false,
    accepts_medicare: false,
    hours_of_operation: {
      monday: '10:00 AM - 4:00 PM',
      tuesday: '10:00 AM - 4:00 PM',
      wednesday: '10:00 AM - 4:00 PM',
      thursday: '10:00 AM - 4:00 PM',
      friday: '10:00 AM - 2:00 PM',
      saturday: 'Closed',
      sunday: 'Closed'
    },
    wheelchair_accessible: true,
    status: 'active'
  },
  {
    id: '5',
    organization_name: 'Tri-Valley Substance Abuse Recovery',
    organization_type: 'Substance Abuse Treatment',
    street_address: '555 Maple Drive',
    city: 'Pleasanton',
    state: 'CA',
    zip_code: '94566',
    latitude: 37.6624,
    longitude: -121.8747,
    primary_phone: '(925) 555-0500',
    primary_email: 'info@tvsar.org',
    website: 'https://example.com',
    distance_miles: 8.2,
    data_quality_score: 85,
    services: ['Substance Abuse Treatment', 'Counseling', 'Support Groups', 'Case Management'],
    languages_spoken: ['English', 'Spanish'],
    accepts_medicaid: true,
    accepts_medicare: true,
    hours_of_operation: {
      monday: '8:00 AM - 8:00 PM',
      tuesday: '8:00 AM - 8:00 PM',
      wednesday: '8:00 AM - 8:00 PM',
      thursday: '8:00 AM - 8:00 PM',
      friday: '8:00 AM - 8:00 PM',
      saturday: '10:00 AM - 2:00 PM',
      sunday: 'Closed'
    },
    wheelchair_accessible: true,
    status: 'active'
  },
  {
    id: '6',
    organization_name: 'Eden Housing Services',
    organization_type: 'Housing Support',
    street_address: '999 Cedar Lane',
    city: 'Hayward',
    state: 'CA',
    zip_code: '94541',
    latitude: 37.6688,
    longitude: -122.0808,
    primary_phone: '(510) 555-0600',
    primary_email: 'housing@eden.org',
    website: 'https://example.com',
    distance_miles: 6.8,
    data_quality_score: 90,
    services: ['Housing Assistance', 'Emergency Shelter', 'Rental Assistance', 'Case Management'],
    languages_spoken: ['English', 'Spanish', 'Tagalog', 'Mandarin'],
    accepts_medicaid: false,
    accepts_medicare: false,
    hours_of_operation: {
      monday: '9:00 AM - 5:00 PM',
      tuesday: '9:00 AM - 5:00 PM',
      wednesday: '9:00 AM - 5:00 PM',
      thursday: '9:00 AM - 5:00 PM',
      friday: '9:00 AM - 5:00 PM',
      saturday: 'Closed',
      sunday: 'Closed'
    },
    wheelchair_accessible: true,
    status: 'active'
  }
];

// Calculate distance between two points using Haversine formula
function calculateDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const R = 3959; // Earth's radius in miles
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

// Mock geocoding for common ZIP codes
const zipCoordinates: Record<string, { lat: number; lng: number }> = {
  '94539': { lat: 37.5485, lng: -121.9886 }, // Fremont
  '94538': { lat: 37.5437, lng: -122.0054 }, // Fremont
  '94536': { lat: 37.5874, lng: -122.0302 }, // Fremont
  '94541': { lat: 37.6688, lng: -122.0808 }, // Hayward
  '94566': { lat: 37.6624, lng: -121.8747 }, // Pleasanton
  '94103': { lat: 37.7749, lng: -122.4194 }, // San Francisco
};

export function mockSearchByZip(zipCode: string, radiusMiles: number, filters?: any) {
  const coords = zipCoordinates[zipCode];
  if (!coords) {
    // Default to Fremont if ZIP not found
    return mockSearchByRadius(37.5485, -121.9886, radiusMiles, filters);
  }
  return mockSearchByRadius(coords.lat, coords.lng, radiusMiles, filters);
}

export function mockSearchByRadius(
  latitude: number,
  longitude: number,
  radiusMiles: number,
  filters?: any
) {
  // Calculate distances and filter by radius
  let results = mockProviders.map(provider => ({
    ...provider,
    distance_miles: calculateDistance(latitude, longitude, provider.latitude!, provider.longitude!)
  })).filter(provider => provider.distance_miles! <= radiusMiles);

  // Apply filters
  if (filters?.organizationType) {
    results = results.filter(p => p.organization_type === filters.organizationType);
  }
  if (filters?.acceptsMedicaid) {
    results = results.filter(p => p.accepts_medicaid);
  }
  if (filters?.acceptsMedicare) {
    results = results.filter(p => p.accepts_medicare);
  }
  if (filters?.services && filters.services.length > 0) {
    results = results.filter(p =>
      filters.services.some((s: string) => p.services.includes(s))
    );
  }
  if (filters?.languagesSpoken && filters.languagesSpoken.length > 0) {
    results = results.filter(p =>
      filters.languagesSpoken.some((l: string) => p.languages_spoken.includes(l))
    );
  }
  if (filters?.minQualityScore) {
    results = results.filter(p => (p.data_quality_score || 0) >= filters.minQualityScore);
  }

  // Sort by distance
  results.sort((a, b) => (a.distance_miles || 0) - (b.distance_miles || 0));

  return {
    providers: results,
    total_count: results.length,
    search_time_ms: 150
  };
}
